import React from "react";
import styled from "styled-components";
import SocialMediaItem from "../../Models/SocialMediaItem";
import {Grid, IconButton} from "@material-ui/core";

interface SocialMediaListItemProp {
    socialMediaItem: SocialMediaItem;
    onClick: (socialMediaItem: SocialMediaItem) => void;
}

const StyledIconButton = styled(IconButton).attrs((props: any) => ({
    socialcolor: props.socialcolor
}))`
  color: ${(props:any) => props.socialcolor || '#393939'}
`;

const SocialMediaListItem = (props: SocialMediaListItemProp) => {
    const {socialMediaItem, onClick} = props;

    return (
        <Grid
            item>
            <StyledIconButton
                socialcolor={socialMediaItem.color}
                onClick={() => onClick(socialMediaItem)}
                >
                {socialMediaItem.icon}
            </StyledIconButton>
        </Grid>
    );
};

export default SocialMediaListItem;